import React from 'react';

export default function PreCacheSharedVar() {
  let [pre_cache_done, setPreCacheDone] = React.useState(false);
  return { pre_cache_done, setPreCacheDone };
}
